<script setup>
import { onMounted, ref } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useModals } from "@/utils/useModals";
import { policyUrl, rulesUrl, agreementUrl } from "@/utils/provider";
import { sendMetrik } from '@/utils/metrika';
import { sendAdriver } from '@/utils/metrika';

const { openModal } = useModals();

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();

const footerRef = ref(null);

onMounted(async () => {
	storeScroll.footer = footerRef.value;
});
</script>
<template>
	<footer class="footer" ref="footerRef" id="footer">
		<div class="container --footer">
			<div class="footer__container">	
				<div class="footer__top">
					<div class="logos">
						<a href="https://www.tretyakovgallery.ru/" target="_blank" rel="noopener noreferrer" class="logo --gallery"><svg width="208" height="50"><use href="#logo_gallery"></use></svg></a>		
						<a href="https://tkmistral.ru/brands/mistral/" target="_blank" rel="noopener noreferrer" class="logo --mistral"><svg width="127" height="50"><use href="#logo_mistral"></use></svg></a>		
						<a href="https://pole.restaurant/" target="_blank" rel="noopener noreferrer" class="logo --place"><img class='' width="217" height="50" src='@/assets/img/logo_place_dark.webp' alt='изображение'></a>
					</div>
					<nav class="footer__nav">
						<a @click="sendAdriver('rules_click'), sendMetrik('reachGoal','Rules_Click')" target="_blank" rel="noopener noreferrer" :href="rulesUrl">Правила акции</a>
						<a target="_blank" rel="noopener noreferrer" :href="policyUrl">Пользовательское соглашение</a>
					</nav>				
				</div>			
				<p class="footer__text">
					Общий срок проведения Акции: 01 декабря 2025 года – по 28 февраля 2026 года (включительно). 
					Сроки совершения покупок Товара, а также регистрации чеков на Сайте: 01 декабря 2025 года – 31 января 2026 года (включительно). 
					Сроки определения Победителей Акции: 01 декабря 2025 года – по 10 февраля 2026 года (включительно). 
					Сроки вручения и передачи всех призов Призового фонда Акции: с 01 декабря 2025 года по 28 февраля 2026 года (включительно).
				</p>
				<p class="footer__text">Erid: 2SDnjd5NEd2, ООО «Мистраль Трейдинг», ИНН 7729569817  </p>
			</div>
		</div>
	</footer>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.footer {
	position: relative;
	padding: 6.8rem 0 5.1rem;
	border-top: 1px solid rgba(14, 14, 14, 0.16);
	z-index: 1;
    @media (max-width: vars.$x480) {
        padding: 4rem 0 2rem;
    }
}
.footer__top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	margin-bottom: 4.3rem;
	@media (max-width: vars.$t) {
		flex-direction: column;
		gap: 1.6rem;
		margin-bottom: 2.5rem;
	}
}
.footer__container {	
	padding-right: 6.8rem;
	@media (max-width: vars.$l) {
		padding-right: 0;
	}
}

.logos {
	display: flex;
	align-items: center;
	gap: 2.3rem;
	@media (max-width: vars.$xx) {
		gap: 1rem;
	}
	@media (max-width: vars.$x480) {
		flex-wrap: wrap;
		justify-content: center;
		gap: 5px 2rem;
	}
}
.logo {
	position: relative;
    z-index: 1;
	--fill: #0e0e0e;
	svg {
		fill: var(--fill);
		stroke: transparent;
	}
	&.--gallery {
		svg {
			width: 20.8rem;
			@media (max-width: vars.$xx) {
				width: 15.7rem;
			}		
		}
	}
	&.--mistral {
		display: flex;
    	align-items: center;
		border-right: 2px solid var(--fill);
		border-left: 2px solid var(--fill);
		padding: 0 2.8rem;
		height: 5rem;
		@media (max-width: vars.$lg) {
			padding: 0 2rem;
		}
		@media (max-width: vars.$xx) {
			height: 3.7rem;
		}
		@media (max-width: vars.$x480) {
			padding: 0 0 0 2rem;
			border-right: 0;
		}
		svg {
			width: 12.7rem;
			@media (max-width: vars.$xx) {
				width: 9.5rem;
				border-width: 1px;
			}
		}
	}
	&.--place {
		svg {
			width: 21.7rem;
			@media (max-width: vars.$xx) {
				width: 18rem;
			}
		}
	}
}

.footer__nav {
	display: flex;
	align-items: center;
	gap: 3rem;
    @media (max-width: vars.$t) {
        flex-direction: column;
        gap: 1.2rem;
    }
    @media (max-width: vars.$x480) {
        
    }
	a {
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 150%;
		color: #0c4ca3;
		border-radius: 10rem;
		padding: 0.6rem 1.8rem;
		border: 1px solid transparent;
		@media (hover: hover) {
			&:hover {
				border-color: currentColor;
			}
		}
		@media (max-width: vars.$xx) {
			padding: 0.6rem 1rem;
			font-size: 1.6rem;
		}
	}
}
.footer__text {
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 140%;
	color: rgba(14, 14, 14, 0.72);
	@media (max-width: vars.$t) {
		text-align: center;
	}
	&:not(:last-child) {
		margin-bottom: 2rem;
	}
}
</style>
